export const CHAT_ACTIONS = [
    { name: 'Configure Reconciliation', text: 'Configure Reconciliation between your systems.', enum: 'configure-reconciliation' },
    { name: 'Do: Monthly Bank Reconciliation', text: 'Perform a month-end bank review.', enum: 'monthly_reconciliation' },
    { name: 'New user set up', text: 'Invite a new employee into the system.', enum: 'onboarding' },
    { name: 'User offboarding', text: 'Remove access and deactivate an employee account.', enum: 'offboarding' },
    { name: 'Suspend user access', text: 'Temporarily disable account access.', enum: 'suspending' },
	{ name: 'External Transactions', text: 'External Transactions', enum: 'external_transactions' },
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]

export const CHAT_ACTIONS_ADMIN = [
    { name: 'New user set up', text: 'Invite a new employee into the system.', enum: 'onboarding' },
    { name: 'User offboarding', text: 'Remove access and deactivate an employee account.', enum: 'offboarding' },
    { name: 'Suspend user access', text: 'Temporarily disable account access.', enum: 'suspending' }
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]